import { IconifyProps } from '@components/iconify';

/**
 * Interface for select option items
 * @interface IOption
 */
export interface IOption {
  /** The option's value used for selection */
  value: number | string;
  /** Display text for the option */
  label: string;
  /** Optional secondary text displayed under the main label (e.g. city) */
  secondaryLabel?: string;
  /** Optional icon to display next to the label */
  icon?: IconifyProps | React.ReactNode;
  /** When true, this specific option becomes non-interactive */
  disabled?: boolean;
  /** Tooltip shown on hover. Also used when the option is disabled, unless `disabledTooltip` is set */
  tooltip?: string;
  /** Tooltip shown on hover only while the option is disabled (e.g. to explain why) */
  disabledTooltip?: string;
}

export enum JToggleGroupVariant {
  DEFAULT = 'default',
  VARIANT = 'variant',
}
